import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AdminTable from "./AdminTable";
import { IconButton } from "@material-ui/core";
import { RefreshRounded } from "@material-ui/icons";
import api from "../../../services/api";
import CircularLoader from "../../UI/Loader";
import { COLORS } from "../../../assets/colors";

function Admins() {
  const [admins, setAdmins] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const response = await api.get("admin/user/admins");
      if (response.status === 200) {
        setAdmins(response.data.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  return (
    <PageWrapper>
      <PageHeader>
        <div className="header-text">
          <h1>Admin Management</h1>
          <p>View and manage administrators of GoSawari.</p>
        </div>
        <HeaderActions>
          <IconButton onClick={() => fetchAdmins()}>
            <RefreshRounded />
          </IconButton>
        </HeaderActions>
      </PageHeader>

      <TableCard>
        {loading ? (
          <CircularLoader isLoading={loading} />
        ) : (
          <AdminTable admins={admins} onRefresh={fetchAdmins} />
        )}
      </TableCard>
    </PageWrapper>
  );
}

export default Admins;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-text {
    h1 {
      margin: 0;
      font-size: 1.875rem;
      font-weight: 700;
      color: ${COLORS.adminTextPrimary};
    }
    p {
      margin: 0.5rem 0 0 0;
      color: ${COLORS.adminTextSecondary};
      font-size: 1rem;
    }
  }
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 1rem;
`;

const TableCard = styled.div`
  background: ${COLORS.adminCardBg};
  border-radius: 12px;
  box-shadow: ${COLORS.adminShadow};
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;
